import { createSlice } from "@reduxjs/toolkit";
import { userNormalLogout, supportLogout } from "../actions";

export interface RecommenderState {
  recommenderConfig: any;
  isChatBotOpen: boolean;
}

const initialState: RecommenderState = {
  recommenderConfig: {},
  isChatBotOpen: false,
};

export const recommenderSlice = createSlice({
  name: "recommender",
  initialState,
  reducers: {
    // Recommendation actions
    getRecommenderConfig: (state) => {},
    saveRecommenderConfig: (state, action) => {
      state.recommenderConfig = action.payload;
    },
    toggleChatBot: (state) => {
      state.isChatBotOpen = !state.isChatBotOpen;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(userNormalLogout, () => initialState)
      .addCase(supportLogout, () => initialState);
  },
});

export const { getRecommenderConfig, saveRecommenderConfig, toggleChatBot } =
  recommenderSlice.actions;

export default recommenderSlice.reducer;
